import PageAnimate from '../modules/page-animate';
import { Tag } from 'main.core';

const smoothState = ($ => {

	const defaultPageOutEffect = 'pageOutLine';
	const defaultPageInEffect = 'pageInLine';

	const HideShowTransition = Barba.BaseTransition.extend({
		start: function() {
			Promise
				.all([this.newContainerLoading, this.fadeOut()])
				.then(this.fadeIn.bind(this));
		},

		fadeOut: function() {

			let deferred = Barba.Utils.deferred(),
				$oldContainer = $(this.oldContainer),
				$dataContainer = $oldContainer.find('.js-smoothData'),
				offsetY = window.pageYOffset,
				animationName = defaultPageOutEffect;

			if (offsetY < 1 && !!$dataContainer.data('page_hide_effect_first_screen'))
			{
				animationName = $dataContainer.data('page_hide_effect_first_screen');
			}
			else if (!!$dataContainer.data('page_hide_effect_second_screen'))
			{
				animationName = $dataContainer.data('page_hide_effect_second_screen');
			}

			this.scrollbarRepaint($(this.oldContainer).find('.js-smooth-content'));

			let animation = new PageAnimate({
				animation: animationName,
				durationOut: 2500,
				onComplete: function(){
					document.body.className = '';
					deferred.resolve();
				}
			});

			animation.start();

			return deferred.promise;
		},

		fadeIn: function()
		{
			let $dataContainer = $(this.newContainer).find('.js-smoothData'),
				animationName = defaultPageInEffect;


			if (!!$dataContainer.data('page_show_effect'))
			{
				animationName = $dataContainer.data('page_show_effect');
			}

			$(this.oldContainer).hide();
			$(this.newContainer).css({visibility: 'visible'});

			this.scrollbarRepaint($(this.newContainer).find('.js-smooth-content'));

			setTimeout(() => {
				$('html').css({'overflow-y': ''});
				$('html').css({width: '', height: '', position: ''});
				$(document).scrollTop(0);
			}, 10);

			let animation = new PageAnimate({
				animation: animationName,
				onComplete: () => {
					this.done();
				}
			});

			animation.start();
		},


        scrollbarRepaint($siteContent)
        {
            let $html = $('html'),
                $win = $(window),
                winH = $win.height();

            if ($siteContent.height() > winH)
            {
                $html.css({'overflow-y': 'scroll'});
            }
            else
            {
                $html.css({'overflow-y': ''});
            }

            // $body.css({width: '', height: '', position: ''});
            // var scrollBarWidth =  window.innerWidth - $body.width();
            // $body.css({width: window.innerWidth - scrollBarWidth, height: window.innerHeight, position: 'fixed'});
            // $html.css({'margin-top': offsetY * -1});
        }
	});

	class smoothState
	{
		constructor()
		{
			this.init();
			this.scripts = [];
			this.HTMLElementContainer = null;
		}

		init()
		{
			const { Barba } = window;
			let usePageLoadAnimation = (RS.Options || {}).usePageLoadAnimation;
			usePageLoadAnimation = usePageLoadAnimation !== undefined && usePageLoadAnimation

			if ($('#bx-panel').length > 0 || !usePageLoadAnimation || !Barba)
				return;

			Barba.Pjax.cacheEnabled = false;
			Barba.Pjax.start();

			// Barba.Prefetch.init();

			Barba.Pjax.getTransition = function() {
				return HideShowTransition;
			};

			Barba.Dispatcher.on(
				'newPageReady',
				(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) => {

					let processed = BX.processHTML(newPageRawHTML, false);
					BX.loadCSS(processed.STYLE);
					this.scripts = processed.SCRIPT;
					processed.HTML = this.injectInlineStyles(processed.HTML);
					this.HTMLElementContainer = HTMLElementContainer;

					if (RS.Panel.openned)
					{
						RS.Panel.close();
					}

					if ($.fancybox.getInstance())
					{
						$.fancybox.close();
					}
				}
			);

			Barba.Dispatcher.on(
				'transitionCompleted',
				async (currentStatus, prevStatus) => {
					if (this.scripts)
					{
						await new Promise(resolve => {
							BX.ajax.processScripts(this.scripts, false, resolve)
						});
						this.scripts = [];
					}

					window.OnLoadPage(this.HTMLElementContainer);
				}
			);

			Barba.Dispatcher.on('linkClicked', function(element, event){
			});
		}

		injectInlineStyles(content)
		{
			let matchStyle;
			const currentStyles = [...document.styleSheets].filter(styleSheet => styleSheet.href == null);
			const newStyles = [];
			let i;

			while ((matchStyle = content.match(/<style([^>]*?)>[\s\S]*?<\/style>/gi)) !== null)
			{
				if (matchStyle[1] && matchStyle[1].match(/href=["\'][^"\']+["\']/i) !== null)
					continue;

				newStyles.push(matchStyle[0]);
				content = content.replace(matchStyle[0], '');
			}

			// remove missing styles
			// for (i in currentStyles)
			// {
			// 	if (newStyles.filter(tagHtml => currentStyles[i].ownerNode.outerHTML == tagHtml) < 1)
			// 	{
			// 		currentStyles[i].disabled = true;
			// 	}
			// }

			for (i in newStyles)
			{
				let currentStyle = currentStyles.filter(styleSheet => styleSheet.ownerNode.outerHTML == newStyles[i])
				if (currentStyle.length < 1)
				{
					document.head.append(Tag.render`${newStyles[i]}`);
				}
				// else if(currentStyle[0].disabled)
				// {
				// 	currentStyle[0].disabled = false;
				// }
			}

			return content;
		}
	}

	return smoothState;
})($);

export default smoothState;
